export const LOCATION_KEYS = {
  all: ['location'] as const,
  regions: () => [...LOCATION_KEYS.all, 'regions'] as const,
  districts: (parentId?: number) => [...LOCATION_KEYS.all, 'districts', parentId] as const,
};
